<template>
  <div class="learn-panel-wrapper">
    <div class="order-list" v-if="orderList.length">
      <div class="item" v-for="(item, index) in orderList" :key="index">
        <div class="cover">
          <img :src="item.trainingCover" />
        </div>
        <div class="order-info">
          <div class="order-name">
            <div class="name">{{ item.trainingName }}</div>
            <div class="total-money">￥{{ item.totalAmount }}</div>
          </div>
          <div class="order-number">
            <span>订单号：</span> {{ item.orderCode }}
          </div>
          <div class="order-time">
            <span>下单时间：</span>{{ item.createTime }}
          </div>

          <div class="bot-wrapper">
            <div class="btn-wrapper">
              <div
                class="btn unpay"
                v-if="item.orderStateCollect === 0"
                @click="
                  $router.push(
                    `/pay?orderId=${item.orderCode}&amount=${item.totalAmount}`
                  )
                "
              >
                去支付
              </div>
              <div
                class="btn finish"
                @click="confirmPay(item)"
                v-if="item.orderStateCollect === 0"
              >
                我已完成支付
              </div>
              <div class="btn checking" v-if="item.orderStateCollect === 1">
                审核中
              </div>
              <div class="btn" @click="handleClickOrderInfo(item)">
                订单详情
              </div>
              <div class="btn" @click="trainingDetailData = item">培训详情</div>
            </div>
            <div :class="['status', `status-${item.orderStateCollect}`]">
              {{ stateTextMap[item.orderStateCollect] }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-empty description="暂无订单信息" v-else></el-empty>
    <div class="pageWrapper" v-if="total > 0">
      <el-pagination
        background
        :page-size="pageSize"
        :current-page="pageNum"
        layout="prev, pager, next"
        :total="total"
        @current-change="
          (page) => {
            this.pageNum = page;
            getData();
          }
        "
      >
      </el-pagination>
    </div>
    <Dialog v-if="activeData" title="订单详情" @close="activeData = null">
      <div class="order-list-detail">
        <div class="list-detail-head">
          <div class="child">姓名</div>
          <div class="child">手机号</div>
          <div class="child">订单状态</div>
          <div class="child">审核意见</div>
          <div class="child action">操作</div>
        </div>
        <div
          class="list-detail-item"
          v-for="item in activeData"
          :key="item.name"
        >
          <div class="child">{{ item.userName }}</div>
          <div class="child">{{ item.phone }}</div>
          <div :class="['child', `status-${item.orderStateCollect}`]">
            {{ item.orderSateValue }}
          </div>
          <div class="child">{{ item.remark }}</div>
          <div class="child action">
            <el-button
              v-if="[1, 4, 5].includes(item.orderState)"
              @click="showContact"
              type="primary"
              size="mini"
              >申请退款
            </el-button>
            <span v-else>-</span>
          </div>
        </div>
      </div>
    </Dialog>
    <trainingDetail
      v-if="trainingDetailData"
      :trainingDetailData="trainingDetailData"
      @close="trainingDetailData = null"
    />
  </div>
</template>

<script>
import { getOrderList, confirmOrder } from "@/api/order";
import Dialog from "@/components/dialog";
import trainingDetail from "./TrainingDialog";

export default {
  components: {
    Dialog,
    trainingDetail,
  },
  data() {
    return {
      orderList: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      stateTextMap: {
        0: "待支付",
        1: "报名审核",
        2: "已完成",
        3: "已关闭",
        4: "申请退款",
      },
      childOrderStatus: {
        0: "待付款",
        1: "已付款",
        2: "取消付款",
        3: "付款超时",
        4: "审核通过",
        5: "审核拒绝",
        6: "部分退款",
        7: "全额退款",
        8: "拒绝退款",
        9: "申请退款",
      },
      activeData: null,
      trainingDetailData: null,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    handleClickOrderInfo(item) {
      this.activeData = item.userList.map((value) => ({
        ...value,
        remark: item.remark,
      }));
    },
    getData() {
      getOrderList({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }).then((res) => {
        const { total = 0, records = [] } = res;
        this.total = total;
        this.orderList = records;
      });
    },
    confirmPay(data) {
      this.$prompt("备注", "我已支付", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputType: "textarea",
      }).then(({ value }) => {
        confirmOrder({
          orderCode: data.orderCode,
          remark: value,
        }).then(() => {
          this.$message({
            type: "success",
            message: "确认成功，已提交审核",
          });
          this.getData();
        });
      });
    },
    showContact() {
      this.$alert("联系人：王滢楠  0571-86829618", "申请退订", {
        confirmButtonText: "确定",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.learn-panel-wrapper {
  border-top: 1px solid #e9e9e9;
  padding-top: 0.3rem;
  .item {
    margin-bottom: 0.4rem;
    display: flex;
    .cover {
      flex: 0 0 2.97rem;
      width: 2.97rem;
      height: 1.91rem;
      background-color: #d4d4d4;
      margin-right: 0.26rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .order-info {
      flex: 1;
      padding-bottom: 0.06rem;
      .order-name {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 0.08rem;
        .name {
          font-size: 0.18rem;
          color: #333;
        }
        .total-money {
          font-size: 0.36rem;
          color: #eb1213;
          font-weight: bold;
        }
      }
      .order-number,
      .order-time {
        font-size: 0.16rem;
        color: #999;
        margin-bottom: 0.15rem;
        span {
          color: #333;
        }
      }
    }
    .bot-wrapper {
      display: flex;
      height: 0.88rem;
      align-items: center;
      justify-content: space-between;
      border-top: 1px solid #e9e9e9;
      .btn-wrapper {
        display: flex;
        justify-content: center;
        .btn {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 1.27rem;
          height: 0.4rem;
          line-height: normal;
          color: #fff;
          font-weight: 500;
          border-radius: 0.04rem;
          cursor: pointer;
          font-size: 0.16rem;
          background: linear-gradient(270deg, #077be2, #34b3e5);
          margin-right: 0.2rem;
          &:last-of-type {
            margin-right: 0;
          }
          &.unpay,
          &.checking {
            background: linear-gradient(270deg, #ff6000, #ff8a00);
          }
          &.finish {
            background: linear-gradient(270deg, #20b574, #23c888);
          }
          &.delete {
            border: 1px solid #0072ff;
            color: #0072ff;
          }
        }
      }
      .status {
        font-size: 0.18rem;
        &.status-0 {
          color: #eb1213;
        }
        &.status-1 {
          color: #ff8a00;
        }
        &.status-2 {
          color: #23c888;
        }
        &.status-3 {
          color: #0072ff;
        }
        &.status-4 {
          color: #d4d4d4;
        }
      }
    }
    .order-title {
      height: 0.7rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid #bcbcbc;
      padding: 0 0.24rem;
      font-size: 0.18rem;
      .order-info {
        color: #666666;
        .sub-title {
          color: #333;
          &:last-of-type {
            margin-left: 0.21rem;
          }
        }
      }
    }
    .info {
      padding: 0.27rem 0.24rem;
      border-left: 1px solid #bcbcbc;
      border-right: 1px solid #bcbcbc;
      display: flex;

      .detail {
        margin-left: 0.27rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .description {
          font-size: 0.16rem;
        }
        .main-teacher {
          margin-top: 0.23rem;
          font-size: 0.16rem;
          span {
            color: #999999;
            margin-left: 6px;
          }
        }
      }
    }
    .bot {
      border: 1px solid #bcbcbc;
      padding: 0.17rem 0.15rem;
      display: flex;
      justify-content: space-between;
      .total-money {
        font-size: 0.26rem;
        color: #eb1213;
        font-weight: bold;
      }
    }
  }

  .order-list-detail {
    display: flex;
    flex-direction: column;
    width: 7.1rem;
    font-size: 0.16rem;
    .list-detail-head {
      padding: 0 0.32rem;
      background-color: rgba(0, 114, 255, 0.1);
      color: rgba(0, 114, 255, 1);
      display: flex;
      .child {
        flex: 1;
        height: 0.4rem;
        line-height: 0.4rem;
        text-align: center;
        align-self: center;
        &.action {
          flex: 0 0 0.8rem;
          width: 0.8rem;
        }
        &.status-0 {
          color: #eb1213;
        }
        &.status-1 {
          color: #ff8a00;
        }

        // &.status-2 {
        //   color: #0072ff;
        // }
        &.status-2 {
          color: #23c888;
        }
      }
    }
    .list-detail-item {
      display: flex;
      padding: 0 0.32rem;
      &:nth-of-type(even) {
        background-color: rgba(0, 114, 255, 0.05);
      }
      .child {
        flex: 1;
        height: auto;
        line-height: 0.4rem;
        text-align: center;
        align-self: center;
        &.action {
          width: 0.8rem;
          flex: 0 0 0.8rem;
        }
      }
    }
  }
  .pageWrapper {
    display: flex;
    padding: 0.4rem 0;
    justify-content: flex-end;
  }
}
</style>
